/* eslint-disable */
import { Illustration } from './components/illustration';
import { ReactComponent as AlerteElement } from '../assets/illustrations/Alerte.svg';
import { ReactComponent as AnnoncesElement } from '../assets/illustrations/Annonces.svg';
import { ReactComponent as ApplicationOKElement } from '../assets/illustrations/ApplicationOK.svg';
import { ReactComponent as AttenteElement } from '../assets/illustrations/Attente.svg';
import { ReactComponent as BinocularBlueElement } from '../assets/illustrations/BinocularBlue.svg';
import { ReactComponent as BinocularJauneElement } from '../assets/illustrations/BinocularJaune.svg';
import { ReactComponent as BinocularLightBlueElement } from '../assets/illustrations/BinocularLightBlue.svg';
import { ReactComponent as BuildingElement } from '../assets/illustrations/Building.svg';
import { ReactComponent as BullesElement } from '../assets/illustrations/Bulles.svg';
import { ReactComponent as BusinessElement } from '../assets/illustrations/Business.svg';
import { ReactComponent as BusinessAElement } from '../assets/illustrations/BusinessA.svg';
import { ReactComponent as BusinessBElement } from '../assets/illustrations/BusinessB.svg';
import { ReactComponent as CaElement } from '../assets/illustrations/Ca.svg';
import { ReactComponent as CartableElement } from '../assets/illustrations/Cartable.svg';
import { ReactComponent as ChariotElement } from '../assets/illustrations/Chariot.svg';
import { ReactComponent as CibleElement } from '../assets/illustrations/Cible.svg';
import { ReactComponent as ClientsElement } from '../assets/illustrations/Clients.svg';
import { ReactComponent as CommandesElement } from '../assets/illustrations/Commandes.svg';
import { ReactComponent as CompteFavorisElement } from '../assets/illustrations/CompteFavoris.svg';
import { ReactComponent as ConflictElement } from '../assets/illustrations/Conflict.svg';
import { ReactComponent as ContactBisElement } from '../assets/illustrations/ContactBis.svg';
import { ReactComponent as ContratsElement } from '../assets/illustrations/Contrats.svg';
import { ReactComponent as DerniereActionCAElement } from '../assets/illustrations/DerniereActionCA.svg';
import { ReactComponent as DerniereRechercheBeigeElement } from '../assets/illustrations/DerniereRechercheBeige.svg';
import { ReactComponent as DerniereRechercheGreenishElement } from '../assets/illustrations/DerniereRechercheGreenish.svg';
import { ReactComponent as DernieresActionsElement } from '../assets/illustrations/DernieresActions.svg';
import { ReactComponent as DonutElement } from '../assets/illustrations/Donut.svg';
import { ReactComponent as EmpreinteElement } from '../assets/illustrations/Empreinte.svg';
import { ReactComponent as EquivalenceElement } from '../assets/illustrations/Equivalence.svg';
import { ReactComponent as EyeElement } from '../assets/illustrations/Eye.svg';
import { ReactComponent as FavorisElement } from '../assets/illustrations/Favoris.svg';
import { ReactComponent as FlecheTTElement } from '../assets/illustrations/FlecheTT.svg';
import { ReactComponent as HeuresElement } from '../assets/illustrations/Heures.svg';
import { ReactComponent as InterimairesElement } from '../assets/illustrations/Interimaires.svg';
import { ReactComponent as LesionsElement } from '../assets/illustrations/Lesions.svg';
import { ReactComponent as LoaderElement } from '../assets/illustrations/Loader.svg';
import { ReactComponent as LoaderSmallElement } from '../assets/illustrations/LoaderSmall.svg';
import { ReactComponent as LookElement } from '../assets/illustrations/Look.svg';
import { ReactComponent as MainsElement } from '../assets/illustrations/Mains.svg';
import { ReactComponent as MapLoadingElement } from '../assets/illustrations/MapLoading.svg';
import { ReactComponent as OiseElement } from '../assets/illustrations/Oise.svg';
import { ReactComponent as OpportunitiesElement } from '../assets/illustrations/Opportunities.svg';
import { ReactComponent as PastequeElement } from '../assets/illustrations/Pasteque.svg';
import { ReactComponent as PauseElement } from '../assets/illustrations/Pause.svg';
import { ReactComponent as PbUniteElement } from '../assets/illustrations/PbUnite.svg';
import { ReactComponent as PermisAElement } from '../assets/illustrations/PermisA.svg';
import { ReactComponent as PermisA1Element } from '../assets/illustrations/PermisA1.svg';
import { ReactComponent as PermisA2Element } from '../assets/illustrations/PermisA2.svg';
import { ReactComponent as PermisAMElement } from '../assets/illustrations/PermisAM.svg';
import { ReactComponent as PermisBElement } from '../assets/illustrations/PermisB.svg';
import { ReactComponent as PermisB1Element } from '../assets/illustrations/PermisB1.svg';
import { ReactComponent as PermisBEElement } from '../assets/illustrations/PermisBE.svg';
import { ReactComponent as PermisCElement } from '../assets/illustrations/PermisC.svg';
import { ReactComponent as PermisC1Element } from '../assets/illustrations/PermisC1.svg';
import { ReactComponent as PermisC1EElement } from '../assets/illustrations/PermisC1E.svg';
import { ReactComponent as PermisCEElement } from '../assets/illustrations/PermisCE.svg';
import { ReactComponent as PermisDElement } from '../assets/illustrations/PermisD.svg';
import { ReactComponent as PermisD1Element } from '../assets/illustrations/PermisD1.svg';
import { ReactComponent as PermisD1EElement } from '../assets/illustrations/PermisD1E.svg';
import { ReactComponent as PermisDEElement } from '../assets/illustrations/PermisDE.svg';
import { ReactComponent as PertinenceElement } from '../assets/illustrations/Pertinence.svg';
import { ReactComponent as PigeElement } from '../assets/illustrations/Pige.svg';
import { ReactComponent as PlusElement } from '../assets/illustrations/Plus.svg';
import { ReactComponent as PrincipaleElement } from '../assets/illustrations/Principale.svg';
import { ReactComponent as RechercheElement } from '../assets/illustrations/Recherche.svg';
import { ReactComponent as RechercheFavoriteElement } from '../assets/illustrations/RechercheFavorite.svg';
import { ReactComponent as RepositioningElement } from '../assets/illustrations/Repositioning.svg';
import { ReactComponent as RepositionnementElement } from '../assets/illustrations/Repositionnement.svg';
import { ReactComponent as ScopeElement } from '../assets/illustrations/Scope.svg';
import { ReactComponent as ScopeIntroElement } from '../assets/illustrations/ScopeIntro.svg';
import { ReactComponent as ServerErrorRedElement } from '../assets/illustrations/ServerErrorRed.svg';
import { ReactComponent as ServerErrorWhiteElement } from '../assets/illustrations/ServerErrorWhite.svg';
import { ReactComponent as ServerErrorYellowElement } from '../assets/illustrations/ServerErrorYellow.svg';
import { ReactComponent as ServerErrorYellowSmallElement } from '../assets/illustrations/ServerErrorYellowSmall.svg';
import { ReactComponent as ServicesElement } from '../assets/illustrations/Services.svg';
import { ReactComponent as TchinElement } from '../assets/illustrations/Tchin.svg';
import { ReactComponent as VideActionsElement } from '../assets/illustrations/VideActions.svg';
import { ReactComponent as VideBleuElement } from '../assets/illustrations/VideBleu.svg';
import { ReactComponent as VidePastequeElement } from '../assets/illustrations/VidePasteque.svg';
import { ReactComponent as VideTransparentElement } from '../assets/illustrations/VideTransparent.svg';

export const Alerte = Illustration(AlerteElement);
export const Annonces = Illustration(AnnoncesElement);
export const ApplicationOK = Illustration(ApplicationOKElement);
export const Attente = Illustration(AttenteElement);
export const BinocularBlue = Illustration(BinocularBlueElement);
export const BinocularJaune = Illustration(BinocularJauneElement);
export const BinocularLightBlue = Illustration(BinocularLightBlueElement);
export const Building = Illustration(BuildingElement);
export const Bulles = Illustration(BullesElement);
export const Business = Illustration(BusinessElement);
export const BusinessA = Illustration(BusinessAElement);
export const BusinessB = Illustration(BusinessBElement);
export const Ca = Illustration(CaElement);
export const Cartable = Illustration(CartableElement);
export const Chariot = Illustration(ChariotElement);
export const Cible = Illustration(CibleElement);
export const Clients = Illustration(ClientsElement);
export const Commandes = Illustration(CommandesElement);
export const CompteFavoris = Illustration(CompteFavorisElement);
export const Conflict = Illustration(ConflictElement);
export const ContactBis = Illustration(ContactBisElement);
export const Contrats = Illustration(ContratsElement);
export const DerniereActionCA = Illustration(DerniereActionCAElement);
export const DerniereRechercheBeige = Illustration(DerniereRechercheBeigeElement);
export const DerniereRechercheGreenish = Illustration(DerniereRechercheGreenishElement);
export const DernieresActions = Illustration(DernieresActionsElement);
export const Donut = Illustration(DonutElement);
export const Empreinte = Illustration(EmpreinteElement);
export const Equivalence = Illustration(EquivalenceElement);
export const Eye = Illustration(EyeElement);
export const Favoris = Illustration(FavorisElement);
export const FlecheTT = Illustration(FlecheTTElement);
export const Heures = Illustration(HeuresElement);
export const Interimaires = Illustration(InterimairesElement);
export const Lesions = Illustration(LesionsElement);
export const Loader = Illustration(LoaderElement);
export const LoaderSmall = Illustration(LoaderSmallElement);
export const Look = Illustration(LookElement);
export const Mains = Illustration(MainsElement);
export const MapLoading = Illustration(MapLoadingElement);
export const Oise = Illustration(OiseElement);
export const Opportunities = Illustration(OpportunitiesElement);
export const Pasteque = Illustration(PastequeElement);
export const Pause = Illustration(PauseElement);
export const PbUnite = Illustration(PbUniteElement);
export const PermisA = Illustration(PermisAElement);
export const PermisA1 = Illustration(PermisA1Element);
export const PermisA2 = Illustration(PermisA2Element);
export const PermisAM = Illustration(PermisAMElement);
export const PermisB = Illustration(PermisBElement);
export const PermisB1 = Illustration(PermisB1Element);
export const PermisBE = Illustration(PermisBEElement);
export const PermisC = Illustration(PermisCElement);
export const PermisC1 = Illustration(PermisC1Element);
export const PermisC1E = Illustration(PermisC1EElement);
export const PermisCE = Illustration(PermisCEElement);
export const PermisD = Illustration(PermisDElement);
export const PermisD1 = Illustration(PermisD1Element);
export const PermisD1E = Illustration(PermisD1EElement);
export const PermisDE = Illustration(PermisDEElement);
export const Pertinence = Illustration(PertinenceElement);
export const Pige = Illustration(PigeElement);
export const Plus = Illustration(PlusElement);
export const Principale = Illustration(PrincipaleElement);
export const Recherche = Illustration(RechercheElement);
export const RechercheFavorite = Illustration(RechercheFavoriteElement);
export const Repositioning = Illustration(RepositioningElement);
export const Repositionnement = Illustration(RepositionnementElement);
export const Scope = Illustration(ScopeElement);
export const ScopeIntro = Illustration(ScopeIntroElement);
export const ServerErrorRed = Illustration(ServerErrorRedElement);
export const ServerErrorWhite = Illustration(ServerErrorWhiteElement);
export const ServerErrorYellow = Illustration(ServerErrorYellowElement);
export const ServerErrorYellowSmall = Illustration(ServerErrorYellowSmallElement);
export const Services = Illustration(ServicesElement);
export const Tchin = Illustration(TchinElement);
export const VideActions = Illustration(VideActionsElement);
export const VideBleu = Illustration(VideBleuElement);
export const VidePasteque = Illustration(VidePastequeElement);
export const VideTransparent = Illustration(VideTransparentElement);
